/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Set_OutcodeInputs */



/**
* | output |
* | --- |
* | "Update the outcode of the selected Event based on the current media time" |
*
* @param {Shortcut_Keys_Desc_Set_OutcodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_set_outcode = /** @type {((inputs?: Shortcut_Keys_Desc_Set_OutcodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Set_OutcodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre a jour l'outcode de l'evenement selectionne selon le temps media actuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisiere den Outcode des ausgewählten Ereignisses basierend auf der aktuellen Medienzeit.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna l'outcode dell'evento selezionato in base all'ora corrente del supporto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновите код вывода выбранного события в соответствии с текущим временем воспроизведения медиафайла.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar el código de salida del evento seleccionado en función del tiempo del medio actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("根据当前媒体时间更新所选事件的输出代码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のメディア時間に基づいて、選択したイベントのアウトコードを更新します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान मीडिया समय के आधार पर चयनित इवेंट के आउटकोड को अपडेट करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualize o código de saída do evento selecionado com base no horário atual da mídia.")
	return /** @type {LocalizedString} */ ("Update the outcode of the selected Event based on the current media time")
});